export class AssociatedBlockRelatedBlock {
  displayId: string;
  id: string;
}
